import { RouteRecordRaw } from 'vue-router'

const profileRoutes: RouteRecordRaw = {
  path: '/profile',
  name: 'Profile',
  component: () => import('@/views/Profile/ProfileLayout.vue'),
  meta: {
    title: '个人中心',
    icon: 'user',
    requiresAuth: true
  },
  redirect: { name: 'OverviewLearning' },
  children: [
    {
      path: 'overview',
      name: 'OverviewLearning',
      component: () => import('@/views/Profile/OverviewLearning.vue'),
      meta: {
        title: '学习概览',
        requiresAuth: true
      }
    },
    {
      path: 'personal',
      name: 'PersonalInfo',
      component: () => import('@/views/Profile/PersonalInfo.vue'),
      meta: {
        title: '个人信息',
        requiresAuth: true
      }
    },
    {
      path: 'pay',
      name: 'PayManage',
      component: () => import('@/views/Profile/PayManage.vue'),
      meta: {
        title: '缴费中心',
        requiresAuth: true
      }
    },
    {
      path: 'assignments',
      name: 'MyAssignments',
      component: () => import('@/views/Profile/MyAssignments.vue'),
      meta: {
        title: '我的作业',
        requiresAuth: true
      }
    },
    {
      path: 'academic',
      name: 'AcademicInfo',
      component: () => import('@/views/Profile/AcademicInfo.vue'),
      meta: {
        title: '学籍档案',
        requiresAuth: true
      }
    },
    {
      path: 'training-plan',
      name: 'TrainingPlan',
      component: () => import('@/views/Profile/TrainingPlan.vue'),
      meta: {
        title: '培养计划',
        requiresAuth: true
      }
    },
    {
      path: 'account',
      name: 'AccountSettings',
      component: () => import('@/views/Profile/AccountSettings.vue'),
      meta: {
        title: '账户设置',
        requiresAuth: true
      }
    },
    {
      path: 'certificate',
      name: 'CertificateManage',
      component: () => import('@/views/Profile/CertificateManage.vue'),
      meta: {
        title: '证书管理',
        requiresAuth: true
      }
    },
    {
      path: 'transcript',
      name: 'TranscriptManage',
      component: () => import('@/views/Profile/TranscriptManage.vue'),
      meta: {
        title: '成绩单',
        requiresAuth: true
      }
    },
    {
      path: 'notification',
      name: 'SystemNotification',
      component: () => import('@/views/Profile/SystemNotification.vue'),
      meta: {
        title: '系统通知',
        requiresAuth: true
      }
    },
    // 用户画像功能暂时隐藏
    // {
    //   path: 'student-portrait',
    //   name: 'StudentPortrait',
    //   component: () => import('@/views/StudentPortrait/index.vue'),
    //   meta: {
    //     title: '用户画像',
    //     requiresAuth: true
    //   }
    // }
  ]
}

export default profileRoutes 